import React, { useState, useEffect } from 'react'
import { Container, } from 'react-bootstrap'
import 'swiper/css';
import 'swiper/css/navigation';
import FAQ from './FAQ';
import faqImage from "../assets/home/About FAQ.png"
import aboutBannerImg from "../assets/home/About banner1.png"
import Piechart from "../Components/PieChart"
import { Helmet } from "react-helmet-async";
import "./AboutUs.css"

const faqData = [
  {
    question: "One Stop for Performance-Driven Digital Campaigns",
    answer: "We turn traffic into conversions with sharp creatives, smart targeting, and campaign optimization."
  },
  {
    question: "One Stop for SEO that Delivers Results",
    answer: "Boost rankings, drive traffic, and generate leads with proven, data-backed SEO strategies."
  },
  {
    question: "One Stop for Growth Marketing That Scales",
    answer: "Fuel business growth with full-funnel strategies, performance media, and data-driven execution."
  },
  {
    question: "One Stop for Content Creation That Connects",
    answer: "Engaging content that stops the scroll and sparks action across all digital platforms."
  },

];
const Counter = ({ end }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const speed = Math.ceil(end / 80); // Adjust speed
    const interval = setInterval(() => {
      start += speed;
      if (start >= end) {
        setCount(end);
        clearInterval(interval);
      } else {
        setCount(start);
      }
    }, 50); // Delay between steps

    return () => clearInterval(interval);
  }, [end]);

  return <h3>{count}+</h3>;
};
const About = () => {
  
  // const [activeIndex, setActiveIndex] = useState(null);
  // const toggleFAQ = (index) => {
  //   setActiveIndex(index === activeIndex ? null : index);
  // };
  return (
    <>
    <Helmet>
  <title>About 21 Maneuvers | Digital Marketing Agency in Bareilly</title>

  <meta 
    name="description" 
    content="Learn about 21 Maneuvers, a leading digital marketing agency in Bareilly delivering SEO, branding, and growth marketing solutions."
  />

  <link rel="canonical" href="https://21maneuvers.in/about" />
</Helmet>
      {/* <Container fluid className='aboutus-banner-section'>
        <Container className='aboutus-banner-heading-div' >
          <p className='page_main_heading'>About Studio </p>
        </Container>
      </Container> */}
        <section className="aboutbanner">
      <img
        src={aboutBannerImg}
        alt="About Banner"
        className="aboutbanner-image"
      />
    </section>
<Container fluid className="about-container-fluid">
  <Container className="about-content-container">
    <div className="about-left-section">
      <h1 style={{
  position: "absolute",
  left: "-9999px",
  height: "1px",
  overflow: "hidden"
}}>
  About Digital Marketing Agency in Bareilly - 21 Maneuvers
</h1>

      <p className="page_text fw-bold">ABOUT US</p>

  <h2 className="page_heading fw-bold">
    We’re 21 Maneuvers,
      </h2>
      <p className="page_text">
       A multidisciplinary force of strategy, story, and style.
      </p>

      <p>
       Driven by curiosity and collaboration, we blend strategic thinking 
       with bold creativity to craft impactful marketing campaigns, digital experiences, and brand stories that inspire action.
      </p>

      <p className='fw-bold quote-text'>
"People do not buy goods and services. They buy relations, stories and magic."<br/>
<span className='signature'>Bharat Aggarwal</span>
      </p>

     
    </div>

   <div className="about-right-section">
  <div className="aboutus-cards">

    {/* Heading */}
    <h3 className="aboutus-heading">Our Creative Process</h3>
    <p className="aboutus-subtext">
      Turning ideas into powerful campaigns through clarity, creativity, and execution.
    </p>

    {/* Cards Row */}
    <div className="aboutus-card-grid">
      <div className="aboutus-card">
        <img src={require("../assets/icon/discovery.png")} alt="Discovery" />
        <h4>Discovery & Strategy</h4>
        <p>Understanding your brand, goals, and audience to build a strong foundation.</p>
      </div>

      <div className="aboutus-card">
        <img src={require("../assets/icon/creative.png")} alt="Creative" />
        <h4>Creative Development</h4>
        <p>Designing ideas that are visually compelling, meaningful, and memorable.</p>
      </div>

      <div className="aboutus-card">
        <img src={require("../assets/icon/execution.png")} alt="Execution" />
        <h4>Execution & Growth</h4>
        <p>Launching, optimizing, and scaling campaigns for measurable impact.</p>
      </div>
    </div>

    {/* Stats Boxes */}
<div className="aboutus-stats">
  <div className="aboutus-stat-box">
    <img src={require("../assets/icon/awards.png")} alt="Awards" />
    <div className="stat-text">
     <Counter end={21} />
      <p>Awards & Recognitions</p>
    </div>
  </div>

  <div className="aboutus-stat-box">
    <img src={require("../assets/icon/happyclient.png")} alt="Clients" />
    <div className="stat-text">
   <Counter end={100} />
      <p>Happy Clients Worldwide</p>
    </div>
  </div>
</div>


  </div>
</div>

  </Container>
</Container>


<Piechart/>
<div className='separation-line'></div>
      {/* About-FAQ-section */}
      <div className='w-auto'>

        <FAQ
          faqs={faqData}
          heading="We work in the fields of art direction."
          image={faqImage}
          imagePosition="left"
        />
      </div>
      {/* About us award section starts */}
      <Container fluid className='about-awards-container-fluid' >
        <Container className='text-center'>
          <p className='page_heading'>21 Steps. One Vision. The Journey Begins.</p><br />
          <p className='page_text'>
            Our story began not in a boardroom, but amidst the vibrant energy of Italy. During their Masters, our founders, 
            fueled by late-night conversations and the timeless pursuit of growth, stumbled upon a profound question over drinks: What are the 21 essential things a brand truly needs to scale? That pivotal discussion sparked a vision. 
            It was in that moment, distilling years of insights into actionable strategies, that the foundation of 21 Maneuvers was laid 
            built on the ambition to empower and scale brands through precise, impactful strategies.
          </p>
        </Container>
      </Container>
      {/* About us award section ends */}

      {/* About-us testimonials section starts */}
      {/* <Container fluid className='about-testimonial-container-fluid'>
        <Container>
          <Row>
            <Col lg={4} md={6} sm={12} xs={12}>
              <p className='page_text fw-bold'>TESTIMONIALS</p>
              <p className='page_heading'>What our clients say about our studio.</p>
            </Col>

            <Col lg={8} md={4} sm={12} xs={12} className='position-relative'>
              <Swiper
                modules={[Navigation, Autoplay]}
                slidesPerView={2}
                slidesPerGroup={2}
                spaceBetween={30}
                navigation={{
                  prevEl: '.testimonial-prev',
                  nextEl: '.testimonial-next',
                }}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                breakpoints={{

                  992: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                  },
                  768: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                  },

                  0: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                  },
                }}
                onInit={(swiper) => {
                  swiper.params.navigation.prevEl = '.testimonial-prev';
                  swiper.params.navigation.nextEl = '.testimonial-next';
                  swiper.navigation.init();
                  swiper.navigation.update();
                }}
                className='testimonial-swiper'
              >
                <SwiperSlide>
                  <div className='about-testimonial-text-div'>
                    <p className='fw-bold'>IT Solutions</p>
                    <p className='page_text'>Within our company, we are a fully independent team of developers, designers, programmers and project managers that work hard to provide our clients with the best technology services and support they need to help them get the best business results they can.</p>
                    <p>Alex Regelman</p>
                    <p>Co-founder, Colabrio</p>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className='about-testimonial-text-div'>
                    <p className='fw-bold'>IT Solutions</p>
                    <p className='page_text'>Within our company, we are a fully independent team of developers, designers, programmers and project managers that work hard to provide our clients with the best technology services and support they need to help them get the best business results they can.</p>
                    <p>Alex Regelman</p>
                    <p>Co-founder, Colabrio</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='about-testimonial-text-div'>
                    <p className='fw-bold'>IT Solutions</p>
                    <p className='page_text'>Within our company, we are a fully independent team of developers, designers, programmers and project managers that work hard to provide our clients with the best technology services and support they need to help them get the best business results they can.</p>
                    <p>Alex Regelman</p>
                    <p>Co-founder, Colabrio</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className='about-testimonial-text-div'>
                    <p className='fw-bold'>IT Solutions</p>
                    <p className='page_text'>Within our company, we are a fully independent team of developers, designers, programmers and project managers that work hard to provide our clients with the best technology services and support they need to help them get the best business results they can.</p>
                    <p>Alex Regelman</p>
                    <p>Co-founder, Colabrio</p>
                  </div>
                </SwiperSlide>

              
                <div className="testimonial-arrows">
                  <button className="testimonial-prev arrow-circle">{'<'}</button>
                  <button className="testimonial-next arrow-circle">{'>'}</button>
                </div>
              </Swiper>
            </Col>

          </Row>
        </Container>
      </Container> */}
      {/* About-us testimonials section ends */}
    </>
  )
}

export default About